export const DEFAULT_COMPANY_LOGO_URL = "/images/logo_default.png";
export const DEFAULT_USER_AVATAR_URL =
  "https://secure.gravatar.com/avatar/39c10b05bc0e3ca2a79707b492eda8e7.png?d=mm&r=PG";

// Tooltip text
export const percentageFeeTooltip = `
The percentage fee displayed is the full amount<br>
attached to this role. In the event of a successful<br>
placement, you would invoice Hiring Hub for 50% of<br>
the total fee payable.
`;

export const exclusiveJobTooltip = `
An exclusive job is defined by Hiring Hub that the<br>
role has not been shared with any other external<br>
recruitment partners. We appreciate that employers<br>
will have their own in-house functions and careers pages.
`;

export const portalJobTooltip = `
Portal clients use the marketplace as an extension of<br>
their direct PSL, and manage all their third-party<br>
permanent recruitment through Hiring Hub 👍
`;

export const premiumJobTooltip = `
Highly engaged: this client is using Hiring Hub’s paid,<br>
Premium Account Service and therefore committed to filling<br>
this role on the platform.
`;
